import { CDefine } from "./CEnumTypes";

export class CMyHand {
	private comP:fgui.GComponent;
	private mcP:fgui.GMovieClip;

	constructor(com:fgui.GComponent) {
		this.comP = com;
		this.mcP = com.getChild("mc_Card") as fgui.GMovieClip;
		this.comP.visible = false;
	}

	public Hide():void { this.comP.visible = false; }

	public Show(value:number, tmShow:number, tmDelay:number = 0, pCallback:Function = null, v:number = 1):void {
		var col:number = 8, row:number = 5, frame:number = 0;
		
		row = ((value & 0x70) >> 4);
		col = (value & 0x0f);
		if ( row < CDefine.MJTYPE_FLOWERS ) frame = (row - 1) * 9 + col;
		else frame = 3 * 9 + 7 + col;
		this.mcP.frame = frame;

		var that = this;
		createjs.Tween.get(this.comP)
					.wait(tmDelay)
					.call(function() {
						that.comP.visible = true;
						let t = that.comP.getTransition("Hand");
						if( pCallback ) {
							t.play(function() {
								that.comP.visible = false;
								pCallback(v);
							});
						}
						else 
							t.play();
					});
	}
}